import _classCallCheck from "/Users/harsha919/Desktop/ONESAZ/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harsha919/Desktop/ONESAZ/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { last, clip_rgb, type } from './utils/index.js';
import _input from './io/input.js';
var Color = /*#__PURE__*/function () {
  function Color() {
    _classCallCheck(this, Color);
    var me = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (type(args[0]) === 'object' && args[0].constructor && args[0].constructor === this.constructor) {
      // the argument is already a Color instance
      return args[0];
    }
    // last argument could be the mode
    var mode = last(args);
    var autodetect = false;
    if (!mode) {
      autodetect = true;
      if (!_input.sorted) {
        _input.autodetect = _input.autodetect.sort(function (a, b) {
          return b.p - a.p;
        });
        _input.sorted = true;
      }

      // auto-detect format
      var _iterator = _createForOfIteratorHelper(_input.autodetect),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var chk = _step.value;
          mode = chk.test.apply(chk, args);
          if (mode) break;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    if (_input.format[mode]) {
      var rgb = _input.format[mode].apply(null, autodetect ? args : args.slice(0, -1));
      me._rgb = clip_rgb(rgb);
    } else {
      throw new Error('unknown format: ' + args);
    }
    // add alpha channel
    if (me._rgb.length === 3) me._rgb.push(1);
  }
  _createClass(Color, [{
    key: "toString",
    value: function toString() {
      if (type(this.hex) == 'function') return this.hex();
      return "[".concat(this._rgb.join(','), "]");
    }
  }]);
  return Color;
}();
export default Color;